module.exports = __webpack_public_path__ + "static/media/map2.d0afe5f8.webp";